import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EnvironmentService } from 'app/core/services/environment.service';
import { RegisterService } from 'app/phoenix2/register/components/register/register.service';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../core/services/config.service';
import { RequestService } from '../../../core/services/request.service';
import {SessionService} from '../../../core/services/session.service';

@Injectable()
export class OrganizationDetailsService {
  isFSPEnv: boolean;
  constructor(
      private configService: ConfigService,
      private requestService: RequestService,
      private sessionService: SessionService,
      private registerService: RegisterService,
      private environmentService: EnvironmentService
  ) {
    this.isFSPEnv = this.environmentService.isFSPEnv;
  }

  sendTestEmail(accId: string): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.sendTestEmail.api +
      '/' +
      accId;
    return this.requestService.post(url, {});
  }

  getSmtpTypes(): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').agora.dictionary.smtpTypes.api;
    return this.requestService.get(url, { verbose: true, type: 'api' });
  }

  updateSmtpDetails(accountId: string, details: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').agora.accounts.editSmtp.api +
      '/' +
      accountId;
    return this.requestService.post(url, details);
  }

  updateSignatories(data: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').agora.accounts.editSignatories.api;
    return this.requestService.post(url, data);
  }

  edit(details: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.edit.api;
    return this.requestService.post(url, details);
  }
  editAccountInfo(accountInfo: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.editAccountInfo.api;
    return this.requestService.post(url, accountInfo);
  }
  editBillingInfo(billingInfo: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.editBillingInfo.api;
    return this.requestService.post(url, billingInfo);
  }
  editSellerInfo(details: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.editSellerInfo.api;
    return this.requestService.post(url, details);
  }
  editAddresses(details: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').agora.accounts.editAddresses.api;
    return this.requestService.post(url, details);
  }
  deleteShippingAddress(id: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.address.deleteShippingAddress.api +
      '/' +
      id;
    return this.requestService.post(url, {});
  }
  getDetails(id: string): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.details.api;
    return this.requestService.get(url);
  }
  checkIfBuyerOnInvoice(): Observable<any> {
      let url = this.configService.get('server').url + this.configService.get('endpoints').organization.organizationDetails.checkIfBuyerOnInvoice.api;
      return this.requestService.get(url);
  }
  isBuyerAvailableForConsumptionVouchers(): Observable<any> {
      let url = this.configService.get('server').url + this.configService.get('endpoints').organization.organizationDetails.isAvailableForConsumptionVouchers.api;
      return this.requestService.get(url);
  }
  getAccountAdmDetails(id: string): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.accountAdmList.api +
      '/' +
      id;
    return this.requestService.get(url);
  }
  getAddresses(domain: string): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').agora.dictionary.address.api +
      '/temp/' +
      domain;
    return this.requestService.get(url, { verbose: true });
  }
  getDomainDetails(): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.domain.details.api;
    return this.requestService.get(url);
  }
  isUserAdminCheck(): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.isUserAccountAdmin.api;
    return this.requestService.get(url);
  }
  makeDomainNameDefault(domainNameId: any): Observable<any> {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.domain.makeDefault.api +
      '/' +
      domainNameId;
    return this.requestService.post(url, {});
  }
  addAlternativeDomain(details: any, domainId: any) {
    let url =
      this.configService.get('server').url +
      this.configService.get('endpoints').organization.domain.addAlternative.api +
      '/' +
      domainId;
    return this.requestService.post(url, details);
  }

  isUserAdmin() {
      return (this.sessionService.hasUserGroup('administrator')
          || this.sessionService.hasUserGroup('buyer-admin')
          || this.sessionService.hasUserGroup('seller-admin'));
  }
  getOverviewEditFields() {
    let fields = [
      {
        key: 'id',
        label: 'id',
        type: 'hidden'
      },
      {
        key: 'name',
        label: 'Legal Name',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.legalName'
      },
      {
        key: 'watermark',
        label: 'Display Name',
        type: 'textbox',
        maxlength: '80',
        tooltipTranslateKey: 'organization.details.edit.tooltip.displayName'
      },
      {
        key: 'accountId',
        label: 'Account ID',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.accountId'
      },
      {
        key: 'email',
        label: 'E-mail',
        type: 'textbox',
        pattern: 'email'
      },
      {
        key: 'organizationType.configValue',
        label: 'Organization Type',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.organizationType'
      },
      {
        key: 'country',
        label: 'Country',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.country'
      },
      {
        key: 'website',
        label: 'Website',
        type: 'textbox',
        pattern:'url'
      }
    ];
    return fields;
  }
  getSellerAccountEditFields() {
    let fields = [
      {
        key: 'aboutSeller',
        label: 'About the Seller',
        type: 'html-editor',
        modules: {
            toolbar: [
                { 'header': [1, 2, 3, 4, 5, 6, false] },
                { 'list': 'ordered' }, { 'list': 'bullet' }
            ]
        }
      },
      {
        key: 'supportEmail',
        label: 'Support Email',
        type: 'textbox',
        pattern: 'email',
        required: true
      },
      {
        key: 'examFulfilmentEmail',
        label: 'Exam Fulfillment Email',
        type: 'textbox',
        pattern: 'email',
        required: true
      },
      {
        key: 'manualDeliveryEmail',
        label: 'Manual Delivery Email',
        type: 'textbox',
        pattern: 'email',
        required: true
      },
      {
        key: 'serviceDeliveryEmail',
        label: 'Service Delivery Email',
        type: 'textbox',
        pattern: 'email',
        required: true
      },
      ...this.isFSPEnv ?
      [{
        key: 'gstRegistrationNumber',
        label: 'GST Registration Number',
        type: 'textbox',
        pattern: 'gst',
        uppercase: true,
        required: true,
        validator: this.validateGSTNumber.bind(this)
      },
      {
        key: 'panNumber',
        label: 'PAN Number',
        type: 'textbox',
        pattern: 'pan',
        uppercase: true,
        required: true,
        validator: this.validatePANNumber.bind(this)
      }] : [],
      {
        key: 'sellerProceedsCurrency.configValue',
        label: 'Settlement Currency',
        type: 'text'
      },
      ...this.isFSPEnv ?
      [{
        key: 'signatureKey',
        label: 'Authorized Signature',
        type: 'img-upload',
        required: true
      },
      {
        key: 'signatureBucket',
        label: 'Authorized Signature Bucket',
        type: 'hidden',
        required: true
      }] : []
    ];
    return fields;
  }
  getBillingEditFields() {
    let fields = [
      {
        key: 'id',
        label: 'id',
        type: 'hidden'
      },
      {
        key: 'currency',
        label: 'Currency',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.currency'
      },
        {
            key: 'paymentTerm',
            label: 'Payment Terms',
            type: this.sessionService.hasUserGroup('buyer') ? 'text' : 'hidden',
            hasTooltip: true,
            tooltipTranslateKey: 'organization.details.edit.tooltip.paymentTerm'
        },
      {
        key: 'creditLimit',
        label: 'Credit Limit',
        type: this.sessionService.hasUserGroup('buyer') ? 'text' : 'hidden',
        hasExtraLink: true,
        manageLink: '/organization/credit'
      },
      {
        key: 'duns',
        label: 'Dun & Bradstreet Number (DUNS)',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.duns'
      },
      {
        key: 'vatNumber',
        label: 'VAT/GST/Tax ID',
        type: 'text',
        hasTooltip: true,
        tooltipTranslateKey: 'organization.details.edit.tooltip.vatNumber'
      },
      {
        key: 'defaultBillToAddressEmail',
        label: 'Billing Email Address',
        type: 'textbox',
        pattern: 'email',
        required: true
      },
      {
        key: 'dunningEmail',
        label: 'Dunning Email Address',
        type: 'textbox',
        pattern: 'email',
        required: true
      },
      {
        key: 'defaultBillToAddress',
        label: 'Billing Address',
        type: 'text',
        hasExtraAction: true,
        actionLabel: '(edit)'
      }
    ];

    return fields;
  }
  getOverviewDetailsFields() {
    let fields = [
      // {
      //     key: 'additionalName',
      //     label: 'Name',
      //     type: 'text'
      // },
      {
        key: 'name',
        label: 'Legal Name',
        type: 'text'
      },
      {
        key: 'watermark',
        label: 'Display Name',
        type: 'text',
        tooltipValueKey: 'organization.details.edit.tooltip.displayName'
      },
      {
        key: 'accountId',
        label: 'Account ID',
        type: 'text'
      },
      {
        key: 'email',
        label: 'E-mail',
        type: 'text'
      },
      {
        key: 'organizationType.configValue',
        label: 'Organization Type',
        type: 'text'
      },
      {
        key: 'country',
        label: 'Country',
        type: 'text'
      },
      {
        key: item => {
          if (item.website && item.website.indexOf('https') !== -1) {
            return item.website;
          } else {
            return 'https://' + item.website;
          }
        },
        label: 'Website',
        type: 'link',
        config: {
          placeholder: 'Website'
        }
      },
      {
        key: _ => {
          return this.configService.getSphinxUrlUnsecured(
            'agora',
            _.signedDocumentBucket,
            _.signedDocumentKey
          );
        },
        label: 'Acknowledged Terms & Conditions',
        type: 'link',
        config: {
          placeholder: 'View'
        }
      }
    ];
    return fields;
  }
  getAccountAdmDetailsFields() {
    let fields = [
      {
        key: 'data',
        type: 'table',
        config: [
          {
            title: 'Contact Name',
            getter: item => {
              return item.firstName + ' ' + item.lastName;
            }
          },
          {
            title: 'Email',
            name: 'email'
          }
        ]
      }
    ];
    return fields;
  }
  getSellerAccountDetailsFields() {
    let fields = [
      {
        id: 'aboutSeller',
        key: 'aboutSeller',
        label: 'About the Seller',
        type: 'html'
      },
      {
        key: 'supportEmail',
        label: 'Support Email',
        type: 'text'
      },
      {
        key: 'examFulfilmentEmail',
        label: 'Exam Fulfillment Email',
        type: 'text'
      },
      {
        key: 'manualDeliveryEmail',
        label: 'Manual Delivery Email',
        type: 'text'
      },
      {
          key: 'serviceDeliveryEmail',
          label: 'Service Delivery Email',
          type: 'text'
      },
      ...this.isFSPEnv ?
      [{
        key: 'gstRegistrationNumber',
        label: 'GST Registration Number',
        type: 'text'
      },
      {
        key: 'panNumber',
        label: 'PAN Number',
        type: 'text'
      }] : [],
      {
        key: 'sellerProceedsCurrency.configValue',
        label: 'Settlement Currency',
        type: 'text'
      },
      ...this.isFSPEnv ?
      [{
        key: 'signatureURL',
        label: 'Authorized Signature',
        type: 'mini-img-preview'
      }] : []
    ];
    return fields;
  }
  getSellerAccountProceedsDetailsFields() {
    let fields = [
      {
        key: 'proceeds',
        label: 'Seller Proceeds',
        type: 'table',
        config: [
          {
            title: 'Type',
            name: 'label'
          },
          {
            title: 'Platform Fee',
            getter: item => {
              return (100 - item.percent) + ' %'
            },
          },
          {
            title: 'Max (USD)',
            name: 'max'
          },
          {
            title: 'Min (USD)',
            name: 'min'
          }
        ]
      }
    ];
    return fields;
  }
  getBillingDetailsFields() {
    let fields = [
      {
        key: 'currency.configValue',
        label: 'Currency',
        type: 'text'
      },
      {
        key: 'duns',
        label: 'Dun & Bradstreet Number (DUNS)',
        type: 'text'
      },
      {
        key: 'vatNumber',
        label: 'VAT/GST/Tax ID',
        type: 'text'
      },
      {
        key: 'defaultBillToAddress.email',
        label: 'Billing Email Address',
        type: 'text'
      },
      {
        key: 'dunningEmail',
        label: 'Dunning Email Address',
        type: 'text'
      },
      {
        key: item => {
          return item.defaultBillToAddress
            ? this.getFormattedAddress(item.defaultBillToAddress)
            : '';
        },
        label: 'Default Billing Address',
        type: 'text'
      }
    ];

    if (this.sessionService.hasUserGroup('buyer')) {
      fields.splice(2, 0,
        {
            key: 'paymentTerm.configValue',
            label: 'Payment Terms',
            type: 'text'
        });

      fields.splice(2, 0,
        {
          key: item => {
            if (item && item.creditLimitAmount) {
              return item.creditLimitCurrency + ' ' + item.creditLimitAmount;
            }
          },
          label: 'Credit Limit',
          type: 'text'
        })
    }
    return fields;
  }
  getBillingAdminDetailsFields() {
    let fields = [
      {
        key: 'currency.configValue',
        label: 'Currency',
        type: 'text'
      },
      {
        key: 'duns',
        label: 'Dun & Bradstreet Number (DUNS)',
        type: 'text'
      },
      {
        key: 'vatNumber',
        label: 'VAT/GST/Tax ID',
        type: 'text'
      },
      {
        key: 'defaultBillToAddress.email',
        label: 'Billing Email Address',
        type: 'text'
      },
      {
        key: 'dunningEmail',
        label: 'Dunning Email Address',
        type: 'text'
      },
      {
        key: item => {
          return item.defaultBillToAddress
            ? this.getFormattedAddress(item.defaultBillToAddress)
            : '';
        },
        label: 'Default Billing Address',
        type: 'text',
        config: {
          hasManageLink: true,
          onClickParam: {
            tab: 'addresses',
            route: '/organization/organization-details'
          }
        }
      }
    ];

    if (this.sessionService.hasUserGroup('buyer')) {
      fields.splice(2, 0,
        {
            key: 'paymentTerm.configValue',
            label: 'Payment Terms',
            type: 'text'
        });

      let creditLimit: any = {
        key: item => {
          if (item && item.creditLimitAmount) {
            return item.creditLimitCurrency + ' ' + item.creditLimitAmount;
          }
        },
        label: 'Credit Limit',
        type: 'text',
        config: {
          hasManageLink: true,
          manageLink: '/organization/credit'
        }
      }

      fields.splice(2, 0, creditLimit);
    }

    return fields;
  }
  getAddressesDetailsFields() {
    let fields = [
      {
        key: item => {
          return item.defaultShipToAddress
            ? this.getFormattedAddress(item.defaultShipToAddress)
            : '';
        },
        label: 'Default Shipping Address',
        type: 'text'
      },
      {
        key: item => {
          return item.defaultBillToAddress
            ? this.getFormattedAddress(item.defaultBillToAddress)
            : '';
        },
        label: 'Billing Address',
        type: 'text'
      }
    ];
    return fields;
  }
  getDetailsPrintLogoFields() {
    let fields = [
      {
        key: 'printLogo',
        label: 'Print Logo',
        type: 'link',
        config: {
          placeholder: 'Download'
        }
      }
    ];
    return fields;
  }
  getDetailsBrandedLogoFields() {
    let fields = [
      {
        key: 'brandedPortalLogo',
        label: 'Branded Portal Logo',
        type: 'link',
        config: {
          placeholder: 'Download'
        }
      }
    ];
    return fields;
  }
  getGmailSmtpFields() {
    return [
      {
        key: 'type.configValue',
        label: 'SMTP type',
        type: 'text'
      },
      {
        key: 'username',
        label: 'Email',
        type: 'text'
      },
      {
        key: 'label',
        label: 'Label',
        type: 'text'
      },
      {
        key: 'isDefault',
        label: 'Activated',
        type: 'text'
      }
    ];
  }
  getDetailsSmtpfields() {
    let fields = [
      {
        key: item => (item.displayName ? `${item.displayName} <${item.from}>` : item.from),
        label: 'From',
        type: 'text'
      },
      {
        key: 'host',
        label: 'Host',
        type: 'text'
      },
      {
        key: 'username',
        label: 'Username',
        type: 'text'
      },
      {
        key: 'port',
        label: 'Port',
        type: 'text'
      },
      {
        key: 'isDefault',
        label: 'Enabled',
        type: 'map',
        map: {
          true: 'Yes',
          false: 'No'
        }
      }
    ];
    return fields;
  }
  getPrimarySignatoryFields() {
    return [
      {
        key: 'primary.name',
        label: 'Name',
        type: 'text'
      },
      {
        key: 'primary.designation',
        label: 'Designation',
        type: 'text'
      }
    ];
  }
  getSecondarySignatoryFields() {
    return [
      {
        key: 'secondary.name',
        label: 'Name',
        type: 'text'
      },
      {
        key: 'secondary.designation',
        label: 'Designation',
        type: 'text'
      }
    ];
  }
  getCertificatesDetailsFields() {
    return [
      {
        key: 'deliveryEnabled',
        label: 'Participation Delivery Enabled',
        type: 'map',
        map: {
          true: 'Yes',
          false: 'No'
        }
      },
      {
        key: 'elearningCompletionDeliveryEnabled',
        label: 'eLearning Completion Delivery Enabled',
        type: 'map',
        map: {
          true: 'Yes',
          false: 'No'
        }
      }
    ];
  }
  getFormattedAddress(address: any) {
    // Synced with Agora. Do not change!
    let keys = ['firstName', 'lastName', 'streetName', 'zipCode', 'country'];
    let result = '';

    keys.forEach((el, i) => {
      if (result.length > 0) result += ' ';
      result += address[el] || '-';
      if (i > 0 && i < 4) result += ' /';
    });

    return result;
  }

  validateGSTNumber(control: AbstractControl) {
    const gstNumber = control.value;
    if (!gstNumber) return Observable.of(null);
    return this.registerService.validateGSTNumber(gstNumber.toUpperCase()).map(res => {
      return res ? null : { custom: { message: 'GST Registration number already exists' } };
    });
  }

  validatePANNumber(control: AbstractControl) {
    const panNumber = control.value;
    if (!panNumber) return Observable.of(null);
    return this.registerService.validatePANNumber(panNumber.toUpperCase()).map(res => {
      return res ? null : { custom: { message: 'PAN number already exists' } };
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details.service.ts